import styled, {css} from 'styled-components'
import {Button} from '@/components/ui/button/Button'

/**
 * Both states keep the ghost variant, so the toggle never carries a border or a shadow: it is the
 * colour alone that separates the closed chain (primary) from the open one (neutral).
 *
 * Scoped to :not(:disabled) so the locked state — the chain from ICD10_MANDATORY_FROM, closed but
 * not operable — keeps the greyed-out colour of a disabled control instead of reading as active.
 */
export const StyledDiagnosisCodesLinkToggle = styled(Button)<{$isLinked: boolean}>(
    ({theme: {palette}, $isLinked}) => css`
        ${$isLinked &&
        css`
            &:not(:disabled) {
                color: ${palette.primary[500]};
                &:hover {
                    color: ${palette.primary[600]};
                }
            }
        `}
    `
)
